window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");
    var $ = window.$;

    require("bootstrap-select");

    require("../../vendor/almasaeed2010/adminlte/plugins/bootstrap/js/bootstrap.min.js");

    require("overlayscrollbars");
    require("../../vendor/almasaeed2010/adminlte/dist/js/adminlte");
} catch (e) { }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });



import Echo from "laravel-echo";

window.io = require("socket.io-client");

let host = window.location.hostname;

window.Echo = new Echo({
    broadcaster: "socket.io",
    host: host,
    client: window.io,
    auth: {
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        }
    }
});

require("./Echo");

/*if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/service-worker.js')
        .then(function () {
            return navigator.serviceWorker.ready;
        })
        .then(function (reg) {
        //    console.log('Service worker registered', reg);

        }).catch(function (err) {
            console.log('erro', err);
        })


    navigator.serviceWorker.addEventListener('message', function (event) {
        console.log(event.data.message); // Hello World !
    });
} */
